export default {"src":"/_next/static/media/sn-logo-border-white.aa67d904.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};